import * as React from "react";
import {createElement, useMemo, useState} from "react";
import {makeStyles} from "@mui/styles";

interface DeliveryIdDisplayProps {
    id: string;
}

export function DeliveryIdDisplay({id}: DeliveryIdDisplayProps) {
    const classes = useStyles();
    const [full, setFull] = useState<boolean>(false);

    const label = useMemo<string>(() => {
        if(full) {
            return id;
        }else {
            return id.slice(0, 4) + '..' + id.slice(id.length-4, id.length);
        }
    }, [id, full]);

    return (<span className={classes.id} onClick={() => setFull(!full)}>{label}</span>);
}

const useStyles = makeStyles(theme => ({
    id: {
        fontFamily: 'monospace',
        cursor: 'pointer'
    }
}));
